import RadioButton from "./radioButton";
import { RadioListWrapper } from "./styles";
import { DisplayName } from "utlis/utils";

const NewRadioCard = ({ list, selected, onChange }) => {
  return (
    <RadioListWrapper>
      {list.map((value, index) => {
        const product_name = value?.display_name;
        return (
          <>
            <section key={index.toString()}>
              <RadioButton
                key={index}
                title={DisplayName(product_name)}
                selected={selected.has(value)}
                onChange={() => onChange(value)}
              />
            </section>
          </>
        );
      })}
    </RadioListWrapper>
  );
};

export default NewRadioCard;
